import React from "react";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { useMyProfile } from "@seabrookstudios/pitch2table";
import { formatNumber, useUserCurrencyFormatter } from "../games/royalties/currency-formatting";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import { CurrencyNotice } from "../games/royalties/CurrencyNotice";
import { preferredCurrencySet, useRoyaltyUnits } from "@seabrookstudios/pitch2table-core";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").RoyaltyEventForApp[]} props.royalties
 * @param {boolean} [props.hideTotal]
 * @param {boolean} [props.hideUnits]
 */
export const RoyaltyTotals = ({ royalties, hideTotal = false, hideUnits = false }) => {
  const { data: profile } = useMyProfile();
  const formatUserCurrency = useUserCurrencyFormatter();

  const total = royalties.reduce((t, royalty) => t + royalty.convertedAmount, 0);
  const paid = royalties.filter((r) => r.paid).reduce((t, royalty) => t + royalty.convertedAmount, 0);

  const totalUnits = useRoyaltyUnits(royalties);
  const royaltyPerUnit = totalUnits ? total / totalUnits : null;

  const hasCurrencySet = preferredCurrencySet(profile);

  return (
    <Box pl={1} pr={1}>
      <List>
        <CurrencyNotice />
        {hasCurrencySet && (
          <Stack direction="row">
            {!hideTotal && (
              <ListItem>
                <ListItemText primary="Total Royalties" secondary={formatUserCurrency(paid)} />
              </ListItem>
            )}
            {total !== paid && (
              <ListItem>
                <ListItemText primary="Total Royalties (including unpaid)" secondary={formatUserCurrency(total)} />
              </ListItem>
            )}
            {!hideUnits && (
              <ListItem>
                <ListItemText primary="Total Units" secondary={formatNumber(totalUnits)} />
              </ListItem>
            )}
            {!hideUnits && (
              <ListItem>
                <ListItemText
                  primary="Royalty Per Unit"
                  secondary={royaltyPerUnit === null ? "—" : formatUserCurrency(royaltyPerUnit)}
                />
              </ListItem>
            )}
          </Stack>
        )}
      </List>
      <Divider />
    </Box>
  );
};
